import { render } from "./Dashboard.vue?vue&type=template&id=38e60382&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=38e60382&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38e60382"

export default script